// @ts-nocheck

import React from 'react';
import type { Node } from 'react';
import styled, { keyframes, css } from 'styled-components';

import { Target } from '../../../../client';

const appear = keyframes`
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
`;

const StyledButton = styled.button`
  &&&& {
    border-radius: 1.3em;
    border: none;
    height: 2.5em;
    padding: 0 1em;
    background-color: #000;

    font-family: BettingPoliticaExtraBold, sans-serif;
    font-weight: 800;
    box-shadow: 0 0.3em 0.5em 0 rgba(0, 0, 0, 0.5);
    cursor: pointer;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    ${Target.__MOBILE__
      ? undefined
      : css`
          &:hover {
            border: solid 1px #fff;
          }
        `}

    &:active {
      transform: scale(0.9);
    }

    ${({ $isSelected, theme }) =>
      $isSelected
        ? css`
            color: #fff;
            border: solid 1px #fff;
          `
        : css`
            color: ${theme.grids.colors.middlegrey3};
            border: solid 1px ${theme.grids.colors.darkgrey5};
          `}
  }
`;

const Center = styled.span`
  width: 100%;
`;

const CheckIcon = styled.svg`
  width: auto;
  height: 0.6em;
  margin: 0 0 0 0.5em;
  stroke: ${({ theme }) => theme.grids.colors.redlight};
  fill: none;
  animation: ${appear} 500ms cubic-bezier(0.64, 2.05, 0.63, 1) forwards;
`;

type Props = {
  className?: string;
  children: Node;
  isSelected: boolean;
  onClick: () => void;
};

const Filter = ({ className, children, onClick, isSelected = false }: Props) => {
  return (
    <StyledButton className={className} $isSelected={isSelected} onClick={onClick}>
      <Center>{children}</Center>
      {isSelected ? (
        <CheckIcon viewBox="0 0 11 6">
          <path d="M 0 3 L 3 6 L 11 0" />
        </CheckIcon>
      ) : null}
    </StyledButton>
  );
};

export default Filter;
